export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 1899 }, (_, i) => {
    const year = String(currentYear - i);
    return { value: year, label: year };
  });
};
